import type { ContentMedia, ContentMediaImage, ContentMediaVideo } from '../../../domain/ContentMedia'
import type { ContentMediaDTO } from '../../../domain/ContentMediaDTO'
import { ContentModelId } from '../../../../../types/ContentModelId'

import { assetDtoToUrl } from '../../../../../utils/asset-dto-to-url'
import { isNonNullableEntryDTO } from '../../../../../utils/non-nullable-entry-dto'

const mapContentMediaImage = (dto: NonNullable<ContentMediaDTO>): ContentMediaImage => {
  const { contentName, mediaImage, mediaImageAlt, mediaImageLink, mediaImageMobile, mediaLegend, mediaSize } =
    dto.fields

  return {
    alt: mediaImageAlt,
    contentType: ContentModelId.CONTENT_MEDIA,
    id: contentName,
    legend: mediaLegend,
    link: mediaImageLink,
    size: mediaSize?.toLowerCase() as ContentMedia['size'],
    source: {
      desktop: assetDtoToUrl(mediaImage),
      mobile: assetDtoToUrl(mediaImageMobile),
    },
    type: 'image',
  }
}

const mapContentMediaVideo = (dto: NonNullable<ContentMediaDTO>): ContentMediaVideo => {
  const { contentName, mediaLegend, mediaSize, mediaVideoUrl } = dto.fields

  return {
    contentType: ContentModelId.CONTENT_MEDIA,
    id: contentName,
    legend: mediaLegend,
    size: mediaSize?.toLowerCase() as ContentMedia['size'],
    source: mediaVideoUrl,
    type: 'video',
  }
}

export const mapContentMediaFromApi = (dto: ContentMediaDTO): ContentMedia | undefined => {
  if (!isNonNullableEntryDTO(dto)) {
    return undefined
  }

  const { mediaVideoUrl } = dto.fields

  return mediaVideoUrl ? mapContentMediaVideo(dto) : mapContentMediaImage(dto)
}
